import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {ZIDXAccountListView} from "../../AccountListView.js";

const $ = jQuery.noConflict();
export class ZIDXAccountSuperAdminLeads implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;

    }

    getPageClass() {
        return "zidxAccountSuperAdminLeadsContainer";
    }


    render() {
        // console.log("SuperAdmin leads");
        let listView=new ZIDXAccountListView(this.zidx);
        listView.render();
        let self=this;
        $(".zidxExportLeadButton", this.zidx.peakidxShadowRoot).on("click", function(){
            self.exportLeads();
        });
    }
    exportLeads() {
        let searchForm = $(".zidxSearchListViewForm", this.zidx.peakidxShadowRoot).serializeArray();
        let exportForm = $("#leads_export_form", this.zidx.peakidxShadowRoot).serializeArray();

        const params = new URLSearchParams();
        for (let field of exportForm)
            params.append(field.name, field.value);
        for (let field of searchForm)
            if (field.name.startsWith("search"))
                params.append(field.name, field.value);

        window.open(`/account/superadmin/leads/export?${params.toString()}`);
    }
}